import { PlusCircle } from "lucide-react";

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
} from "@components/common/menu-bar";
import { Context, useModal } from "@stores/modal-store";
import useTranslator from "@hooks/use-translator";

const AddToWorkspace = () => {
  const modal = useModal();
  const { translate } = useTranslator();

  const handleClick = (context: Context) => {
    modal.onOpen();
    modal.setContext(context);
  };

  return (
    <div className="z-50 hidden items-center md:flex">
      <Menubar className="border-none bg-none">
        <MenubarMenu>
          <MenubarTrigger className="bg-primary text-white flex items-center justify-between rounded-full p-1 border bg-none">
            <PlusCircle />
          </MenubarTrigger>
          <MenubarContent className="mx-2 bg-background">
            <MenubarItem onClick={() => handleClick("project")}>
              {translate(`Create Project`)}
            </MenubarItem>
            <MenubarSeparator />
            <MenubarItem onClick={() => handleClick("task")}>
              {translate("Create Task")}
            </MenubarItem>
            <MenubarSeparator />
            <MenubarItem onClick={() => handleClick("invite")}>
              {translate("Invite User")}
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
    </div>
  );
};

export default AddToWorkspace;
